enum ActionTypes {
  UPDATE_EMAIL = 'UPDATE_EMAIL',
  UPDATE_PASSWORD = 'UPDATE_PASSWORD',
  SUBMIT_ERROR = 'SUBMIT_ERROR',
  SUBMIT_API_STATUS = 'SUBMIT_API_STATUS',
}

enum FRONTEND_VERIFICATION_ERRORS {
  INVALID_EMAIL = 'invalid_email',
  EMAIL_REQUIRED = 'email_required',
  INVALID_EMAIL_SUBMITTED = 'invalid_email_submitted',
  PASSWORD_REQUIRED = 'password_required',
  SOMETHING_WENT_WRONG = 'something_went_wrong',
}

enum BACKEND_ERROR_CODES {
  PENDING_VERIFICATION = 'pending_verification',
  USER_NOT_FOUND = 'user_not_found',
  MFA_ALREADY_DISABLED = 'mfa_already_disable',
  INVALID_PASSWORD = 'invalid_password',
  DELETED_ACCOUNT_EXISTS = 'deleted_account_exists',
  BCRYPT_HASH_LIMIT = 'bcrypt_hash_limit',
  LOGIN_BLOCKED = 'login_blocked',
  VERIFY_EMAIL_BLOCKED = 'verify_email_blocked',
  PASSWORD_NOT_SET = 'password_not_set',
  KYC_NOT_APPROVED = 'kyc_not_approved',
}

export { ActionTypes, FRONTEND_VERIFICATION_ERRORS, BACKEND_ERROR_CODES };
